import Util from '@/lib/util'
export default [
    {
        title:Util.L('SKU'),
        width:150,
        fixed:'left',
        key:'sku'
  },{
        title:Util.L('InventoryAging_D90'),
        width:120,
        key:'d90',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.d90));
        }
  },{
        title:Util.L('InventoryAging_D180'),
        width:120,
        key:'d180',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.d180));
        }
  },{
        title:Util.L('InventoryAging_D270'),
        width:120,
        key:'d270',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.d270));
        }
  },{
        title:Util.L('InventoryAging_D360'),
        width:120,
        key:'d360',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.d360));
        }
  },{
        title:Util.L('InventoryAging_D361'),
        width:120,
        key:'d361',
        align: "right",
        render: (h: any, params: any) => {
            return h("span", Util.toViewNumberString(params.row.d361));
        }
  },
  {
        title:Util.L('ProductName'),
        width:150,
        key:'productName'
  },
  {
        title:Util.L('AssetType'),
        width:150,
        key:'assetTypeName'
  },
  {
        title:Util.L('ConditionType'),
        width:150,
        key:'conditionTypeName'
  }]